export default __webpack_public_path__ + "static/media/miscllenious.a1412079.svg";